import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BooleanParam, useQueryParam } from 'use-query-params';
import { acceptCookies, declineCookies, initialize } from 'utils/trackers/analytics';

const useCookieBannerViewModel = () => {
  const { t } = useTranslation();

  const [disableGa] = useQueryParam('disableGa', BooleanParam);
  const [isVisible, setIsVisible] = useState(false);

  const handleAccept = () => {
    acceptCookies();
    initialize();
    setIsVisible(false);
  };

  const handleDecline = () => {
    declineCookies();
    setIsVisible(false);
  };

  useEffect(() => {
    const showBanner = initialize();
    setIsVisible(disableGa === true ? false : showBanner);
  }, []);

  return {
    isVisible,
    viewProps: {
      title: t('general:cookieBanner.title'),
      description: t('general:cookieBanner.description'),
      acceptButtonText: t('general:accept'),
      declineButtonText: t('general:cancel'),
      onAccept: handleAccept,
      onDecline: handleDecline,
    },
  };
};

export default useCookieBannerViewModel;
